// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PBorderTopOutlinedSvg from "@fishx/icons-svg/es/asn/PBorderTopOutlined";
import FishxIcon from '../components/FishxIcon';

var PBorderTopOutlined = function PBorderTopOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PBorderTopOutlinedSvg
  }));
};

PBorderTopOutlined.displayName = 'PBorderTopOutlined';
export default React.forwardRef(PBorderTopOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PBorderTopOutlined.js
// module id = 3251
// module chunks = 0